// Global Constants
const $DOM = {
	win:     $(window),
	doc:     $(document),
	htmlTag: $('html,body'),
	bodyTag: $('body')
}

const classes = {
	Hover:            'hover',
	Active:           'active',
	IsTouch:          'is-touch',
	OwlContainer:     'owl-carousel',
	ShowFixedHeader:  'show-fixed-header',
	ShowHeaderSearch: 'show-header-search',
	ShowNavMain:      'show-nav-main',
	ShowScrollbar:    'show-scrollbar',
	PageLoaded: 	  'page-loaded',
	IsIos: 			  'is-ios'
};

// Import.Components
import IsTouch from './components/is-touch';
import AddBodyClassOnPageLoad from './components/add-body-class-on-page-load';
import AddFixedHeaderClassOnScroll from './components/add-fixed-header-slass-on-scroll';
import BtnHamburger from './components/btn-hamburger';
import outOfTheTargetOnTouch from './components/out-of-the-target-on-click-on-touch';
import AddClassOnNavWithChildOnMobile from './components/add-class-on-nav-with-child-on-touch';
import FormSearchHeader from './components/form-search-header';
import FragmentTable from './components/fragment-table';
import AccordionMain from './components/accordion-main';
import SliderReview from './components/slider-review';
import SliderTestimonials from './components/slider-testimonials';
import BtnReview from './components/btn-review';
import BtnNextSection from './components/btn-next-section';
import BtnCoupon from './components/btn-coupon';
import FormFieldRating from './components/form-field-rating';
import ScrollAnimation from './components/scroll-animation';
import IsIos from './components/is-ios';
import InitLazyLoad from './components/jquery-lazy-load';

// Init.Components
IsTouch($DOM, classes);
IsIos($DOM, classes);
AddBodyClassOnPageLoad($DOM, classes);
AddFixedHeaderClassOnScroll($DOM, classes);
BtnHamburger($DOM, classes);
outOfTheTargetOnTouch($DOM, '.nav', '.nav li', classes);
AddClassOnNavWithChildOnMobile($DOM, '.nav a', '> ul', classes);
FormSearchHeader($DOM, classes);
FragmentTable($DOM, classes);
AccordionMain($DOM, classes);
SliderReview($DOM, classes);
SliderTestimonials($DOM, classes);
BtnReview($DOM, classes);
BtnNextSection($DOM, classes);
BtnCoupon($DOM, classes);
FormFieldRating($DOM, classes);
ScrollAnimation($DOM, classes);
InitLazyLoad($DOM, classes);